import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ManageCRRAModel } from 'src/Models/ManageCRRAModel';
import { ManageCrraMasterService } from 'src/Services/manage-crra-master.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-crrahome',
  templateUrl: './crrahome.component.html',
  styleUrls: ['./crrahome.component.css']
})
export class CRRAHomeComponent implements OnInit {

  tokenKey: string = '';
  objManageCRRAModel = new ManageCRRAModel();
  
  constructor(private readonly titleService: Title, 
    private readonly manageCrraMaster: ManageCrraMasterService,
    private sessionStorageService: SessionStorageService) {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.titleService.setTitle('Home | JSi360');
   }

  ngOnInit() {

    this.getHomeDetail();
  }

  getHomeDetail(){
    this.manageCrraMaster.GetManageCRRADetails(this.tokenKey).subscribe(data => {
      if (data['status'] !== 'Failure') {
        this.objManageCRRAModel = data.result;
      }
    });
  }
}
